import { render, staticRenderFns } from "./ApprovedPayments.vue?vue&type=template&id=9eb49ac8"
import script from "./ApprovedPayments.vue?vue&type=script&lang=js"
export * from "./ApprovedPayments.vue?vue&type=script&lang=js"
import style0 from "./ApprovedPayments.vue?vue&type=style&index=0&id=9eb49ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports